/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApiIntegrationResponse } from '../models/api-integration-response';
import { AssociateGrantElevatedRequestDto } from '../models/associate-grant-elevated-request-dto';
import { CancelElevatedRequestResponse } from '../models/cancel-elevated-request-response';
import { CreateApiIntegrationDto } from '../models/create-api-integration-dto';
import { CreateApiIntegrationResponse } from '../models/create-api-integration-response';
import { CreateElevatedRequestResponse } from '../models/create-elevated-request-response';
import { DeleteElevatedUserResponse } from '../models/delete-elevated-user-response';
import { DeleteOrganizationResponse } from '../models/delete-organization-response';
import { ElevateUserResponse } from '../models/elevate-user-response';
import { ElevatedRequestPostDto } from '../models/elevated-request-post-dto';
import { ElevatedUserDto } from '../models/elevated-user-dto';
import { GenerateClientCredentialResponse } from '../models/generate-client-credential-response';
import { GetAuditElevatedRequestsResponse } from '../models/get-audit-elevated-requests-response';
import { GetClientCredentialResponse } from '../models/get-client-credential-response';
import { GetElevatedRequestResponse } from '../models/get-elevated-request-response';
import { GetElevatedUsersResponseDto } from '../models/get-elevated-users-response-dto';
import { UpdateApiIntegrationResponse } from '../models/update-api-integration-response';
import { UpdateElevatedRequestDto } from '../models/update-elevated-request-dto';
import { UpdateElevatedRequestResponse } from '../models/update-elevated-request-response';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation deleteOrganization
   */
  static readonly DeleteOrganizationPath = '/api/v1/{organizationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrganization()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrganization$Response(params: {
    organizationId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<DeleteOrganizationResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.DeleteOrganizationPath, 'delete');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeleteOrganizationResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteOrganization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrganization(params: {
    organizationId: string;
    context?: HttpContext
  }
): Observable<DeleteOrganizationResponse> {

    return this.deleteOrganization$Response(params).pipe(
      map((r: StrictHttpResponse<DeleteOrganizationResponse>) => r.body as DeleteOrganizationResponse)
    );
  }

  /**
   * Path part for operation getApiIntegration
   */
  static readonly GetApiIntegrationPath = '/api/v1/api-integration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiIntegration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiIntegration$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ApiIntegrationResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.GetApiIntegrationPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApiIntegrationResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getApiIntegration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiIntegration(params?: {
    context?: HttpContext
  }
): Observable<ApiIntegrationResponse> {

    return this.getApiIntegration$Response(params).pipe(
      map((r: StrictHttpResponse<ApiIntegrationResponse>) => r.body as ApiIntegrationResponse)
    );
  }

  /**
   * Path part for operation createApiIntegration
   */
  static readonly CreateApiIntegrationPath = '/api/v1/api-integration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createApiIntegration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiIntegration$Response(params: {
    context?: HttpContext
    body: CreateApiIntegrationDto
  }
): Observable<StrictHttpResponse<CreateApiIntegrationResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.CreateApiIntegrationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateApiIntegrationResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createApiIntegration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiIntegration(params: {
    context?: HttpContext
    body: CreateApiIntegrationDto
  }
): Observable<CreateApiIntegrationResponse> {

    return this.createApiIntegration$Response(params).pipe(
      map((r: StrictHttpResponse<CreateApiIntegrationResponse>) => r.body as CreateApiIntegrationResponse)
    );
  }

  /**
   * Path part for operation generateClientCredential
   */
  static readonly GenerateClientCredentialPath = '/api/v1/api-integration/{integrationId}/clientCredential';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateClientCredential()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateClientCredential$Response(params: {
    integrationId: string;
    context?: HttpContext

    /**
     * Empty body.
     */
    body?: {
}
  }
): Observable<StrictHttpResponse<GenerateClientCredentialResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.GenerateClientCredentialPath, 'post');
    if (params) {
      rb.path('integrationId', params.integrationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenerateClientCredentialResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateClientCredential$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateClientCredential(params: {
    integrationId: string;
    context?: HttpContext

    /**
     * Empty body.
     */
    body?: {
}
  }
): Observable<GenerateClientCredentialResponse> {

    return this.generateClientCredential$Response(params).pipe(
      map((r: StrictHttpResponse<GenerateClientCredentialResponse>) => r.body as GenerateClientCredentialResponse)
    );
  }

  /**
   * Path part for operation deleteApiIntegration
   */
  static readonly DeleteApiIntegrationPath = '/api/v1/api-integration/{integrationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiIntegration()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiIntegration$Response(params: {
    integrationId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<DeleteOrganizationResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.DeleteApiIntegrationPath, 'delete');
    if (params) {
      rb.path('integrationId', params.integrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeleteOrganizationResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteApiIntegration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiIntegration(params: {
    integrationId: string;
    context?: HttpContext
  }
): Observable<DeleteOrganizationResponse> {

    return this.deleteApiIntegration$Response(params).pipe(
      map((r: StrictHttpResponse<DeleteOrganizationResponse>) => r.body as DeleteOrganizationResponse)
    );
  }

  /**
   * Path part for operation updateApiIntegration
   */
  static readonly UpdateApiIntegrationPath = '/api/v1/api-integration/{integrationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateApiIntegration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateApiIntegration$Response(params: {
    integrationId: string;
    context?: HttpContext
    body: CreateApiIntegrationDto
  }
): Observable<StrictHttpResponse<UpdateApiIntegrationResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.UpdateApiIntegrationPath, 'patch');
    if (params) {
      rb.path('integrationId', params.integrationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateApiIntegrationResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateApiIntegration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateApiIntegration(params: {
    integrationId: string;
    context?: HttpContext
    body: CreateApiIntegrationDto
  }
): Observable<UpdateApiIntegrationResponse> {

    return this.updateApiIntegration$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateApiIntegrationResponse>) => r.body as UpdateApiIntegrationResponse)
    );
  }

  /**
   * Path part for operation getClientCredential
   */
  static readonly GetClientCredentialPath = '/api/v1/api-integration/{integrationId}/clientCredential/{clientCredentialId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientCredential()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientCredential$Response(params: {
    integrationId: string;
    clientCredentialId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GetClientCredentialResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.GetClientCredentialPath, 'get');
    if (params) {
      rb.path('integrationId', params.integrationId, {});
      rb.path('clientCredentialId', params.clientCredentialId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetClientCredentialResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClientCredential$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientCredential(params: {
    integrationId: string;
    clientCredentialId: string;
    context?: HttpContext
  }
): Observable<GetClientCredentialResponse> {

    return this.getClientCredential$Response(params).pipe(
      map((r: StrictHttpResponse<GetClientCredentialResponse>) => r.body as GetClientCredentialResponse)
    );
  }

  /**
   * Path part for operation deleteClientCredential
   */
  static readonly DeleteClientCredentialPath = '/api/v1/api-integration/{integrationId}/clientCredential/{clientCredentialId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteClientCredential()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClientCredential$Response(params: {
    integrationId: string;
    clientCredentialId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<DeleteOrganizationResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.DeleteClientCredentialPath, 'delete');
    if (params) {
      rb.path('integrationId', params.integrationId, {});
      rb.path('clientCredentialId', params.clientCredentialId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeleteOrganizationResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteClientCredential$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClientCredential(params: {
    integrationId: string;
    clientCredentialId: string;
    context?: HttpContext
  }
): Observable<DeleteOrganizationResponse> {

    return this.deleteClientCredential$Response(params).pipe(
      map((r: StrictHttpResponse<DeleteOrganizationResponse>) => r.body as DeleteOrganizationResponse)
    );
  }

  /**
   * Path part for operation cancelElevatedRequest
   */
  static readonly CancelElevatedRequestPath = '/api/v1/elevatedrequest/{elevatedRequestId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelElevatedRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelElevatedRequest$Response(params: {
    elevatedRequestId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<CancelElevatedRequestResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.CancelElevatedRequestPath, 'delete');
    if (params) {
      rb.path('elevatedRequestId', params.elevatedRequestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CancelElevatedRequestResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelElevatedRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelElevatedRequest(params: {
    elevatedRequestId: string;
    context?: HttpContext
  }
): Observable<CancelElevatedRequestResponse> {

    return this.cancelElevatedRequest$Response(params).pipe(
      map((r: StrictHttpResponse<CancelElevatedRequestResponse>) => r.body as CancelElevatedRequestResponse)
    );
  }

  /**
   * Path part for operation updateElevatedRequest
   */
  static readonly UpdateElevatedRequestPath = '/api/v1/elevatedrequest/{elevatedRequestId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateElevatedRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateElevatedRequest$Response(params: {
    elevatedRequestId: string;
    context?: HttpContext
    body: UpdateElevatedRequestDto
  }
): Observable<StrictHttpResponse<UpdateElevatedRequestResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.UpdateElevatedRequestPath, 'patch');
    if (params) {
      rb.path('elevatedRequestId', params.elevatedRequestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateElevatedRequestResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateElevatedRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateElevatedRequest(params: {
    elevatedRequestId: string;
    context?: HttpContext
    body: UpdateElevatedRequestDto
  }
): Observable<UpdateElevatedRequestResponse> {

    return this.updateElevatedRequest$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateElevatedRequestResponse>) => r.body as UpdateElevatedRequestResponse)
    );
  }

  /**
   * Path part for operation associateGrantElevatedRequest
   */
  static readonly AssociateGrantElevatedRequestPath = '/api/v1/elevatedrequest/associategrant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `associateGrantElevatedRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  associateGrantElevatedRequest$Response(params: {
    context?: HttpContext
    body: AssociateGrantElevatedRequestDto
  }
): Observable<StrictHttpResponse<UpdateElevatedRequestResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.AssociateGrantElevatedRequestPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateElevatedRequestResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `associateGrantElevatedRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  associateGrantElevatedRequest(params: {
    context?: HttpContext
    body: AssociateGrantElevatedRequestDto
  }
): Observable<UpdateElevatedRequestResponse> {

    return this.associateGrantElevatedRequest$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateElevatedRequestResponse>) => r.body as UpdateElevatedRequestResponse)
    );
  }

  /**
   * Path part for operation getElevatedRequest
   */
  static readonly GetElevatedRequestPath = '/api/v1/elevatedrequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getElevatedRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getElevatedRequest$Response(params: {
    organizationId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GetElevatedRequestResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.GetElevatedRequestPath, 'get');
    if (params) {
      rb.query('organizationId', params.organizationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetElevatedRequestResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getElevatedRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getElevatedRequest(params: {
    organizationId: string;
    context?: HttpContext
  }
): Observable<GetElevatedRequestResponse> {

    return this.getElevatedRequest$Response(params).pipe(
      map((r: StrictHttpResponse<GetElevatedRequestResponse>) => r.body as GetElevatedRequestResponse)
    );
  }

  /**
   * Path part for operation createElevatedRequest
   */
  static readonly CreateElevatedRequestPath = '/api/v1/elevatedrequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createElevatedRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createElevatedRequest$Response(params: {
    context?: HttpContext
    body: ElevatedRequestPostDto
  }
): Observable<StrictHttpResponse<CreateElevatedRequestResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.CreateElevatedRequestPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateElevatedRequestResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createElevatedRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createElevatedRequest(params: {
    context?: HttpContext
    body: ElevatedRequestPostDto
  }
): Observable<CreateElevatedRequestResponse> {

    return this.createElevatedRequest$Response(params).pipe(
      map((r: StrictHttpResponse<CreateElevatedRequestResponse>) => r.body as CreateElevatedRequestResponse)
    );
  }

  /**
   * Path part for operation elevatedUsers
   */
  static readonly ElevatedUsersPath = '/api/v2/elevatedUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elevatedUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  elevatedUsers$Response(params?: {
    deleted?: boolean;
    pageSize?: number;
    page?: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GetElevatedUsersResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.ElevatedUsersPath, 'get');
    if (params) {
      rb.query('deleted', params.deleted, {});
      rb.query('pageSize', params.pageSize, {});
      rb.query('page', params.page, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetElevatedUsersResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elevatedUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elevatedUsers(params?: {
    deleted?: boolean;
    pageSize?: number;
    page?: number;
    context?: HttpContext
  }
): Observable<GetElevatedUsersResponseDto> {

    return this.elevatedUsers$Response(params).pipe(
      map((r: StrictHttpResponse<GetElevatedUsersResponseDto>) => r.body as GetElevatedUsersResponseDto)
    );
  }

  /**
   * Path part for operation createElevatedUser
   */
  static readonly CreateElevatedUserPath = '/api/v2/elevatedUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createElevatedUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createElevatedUser$Response(params: {
    context?: HttpContext
    body: ElevatedUserDto
  }
): Observable<StrictHttpResponse<ElevateUserResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.CreateElevatedUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElevateUserResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createElevatedUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createElevatedUser(params: {
    context?: HttpContext
    body: ElevatedUserDto
  }
): Observable<ElevateUserResponse> {

    return this.createElevatedUser$Response(params).pipe(
      map((r: StrictHttpResponse<ElevateUserResponse>) => r.body as ElevateUserResponse)
    );
  }

  /**
   * Path part for operation deleteElevatedUser
   */
  static readonly DeleteElevatedUserPath = '/api/v2/elevatedUsers/{elevatedId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteElevatedUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteElevatedUser$Response(params: {
    elevatedId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<DeleteElevatedUserResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.DeleteElevatedUserPath, 'delete');
    if (params) {
      rb.path('elevatedId', params.elevatedId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeleteElevatedUserResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteElevatedUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteElevatedUser(params: {
    elevatedId: string;
    context?: HttpContext
  }
): Observable<DeleteElevatedUserResponse> {

    return this.deleteElevatedUser$Response(params).pipe(
      map((r: StrictHttpResponse<DeleteElevatedUserResponse>) => r.body as DeleteElevatedUserResponse)
    );
  }

  /**
   * Path part for operation getAuditElevatedRequests
   */
  static readonly GetAuditElevatedRequestsPath = '/api/v1/elevatedrequest/audit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuditElevatedRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuditElevatedRequests$Response(params?: {
    organizationId?: string;
    inactive?: boolean;
    startdate?: string;
    enddate?: string;
    page?: number;
    pagesize?: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GetAuditElevatedRequestsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsApiService.GetAuditElevatedRequestsPath, 'get');
    if (params) {
      rb.query('organizationId', params.organizationId, {});
      rb.query('inactive', params.inactive, {});
      rb.query('startdate', params.startdate, {});
      rb.query('enddate', params.enddate, {});
      rb.query('page', params.page, {});
      rb.query('pagesize', params.pagesize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetAuditElevatedRequestsResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAuditElevatedRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuditElevatedRequests(params?: {
    organizationId?: string;
    inactive?: boolean;
    startdate?: string;
    enddate?: string;
    page?: number;
    pagesize?: number;
    context?: HttpContext
  }
): Observable<GetAuditElevatedRequestsResponse> {

    return this.getAuditElevatedRequests$Response(params).pipe(
      map((r: StrictHttpResponse<GetAuditElevatedRequestsResponse>) => r.body as GetAuditElevatedRequestsResponse)
    );
  }

}
